export enum ObjectModelTriggerType {
  DefaultTrigger =0,
  AutoGenerateForm = 1,
  AutomaticNotification = 2,
  UpdatePropertyValues = 3,
  RunMapping = 4,
  LogEventInHistory = 5,
  RemoveRelationship = 6,
  EstablishRelationship = 7,
  RunProcess = 8,
}
